import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../config/environments/environment';
import { Observable } from 'rxjs';
import { Show } from '../models';
import { CreateShowDto, ShowParamsDto, UpdateShowDto } from '../dtos';

@Injectable()
export class ShowsService {

  private readonly path = 'shows';

  constructor(
    private readonly http: HttpClient
  ) { }

  findAll(params?: ShowParamsDto): Observable<Show[]> {
    const url = `${environment.api.baseUrl}/${this.path}`;

    const httpParams = this.buildHttpParams(params);
    return this.http
      .get<Show[]>(url, { params: httpParams })
      .pipe((response) => response);
  }

  findById(id: string): Observable<Show> {
    return this.http
      .get<Show>(`${environment.api.baseUrl}/${this.path}/${id}`)
      .pipe((response) => response);
  }


  create(create: CreateShowDto): Observable<String> {
    return this.http.post(`${environment.api.baseUrl}/${this.path}`,
      create, {
      responseType: 'text',
    });
  }

  update(id: string, update: UpdateShowDto): Observable<any> {
    return this.http.put(`${environment.api.baseUrl}/${this.path}/${id}`,
      update,
      {}
    );
  }

  activate(id: string): Observable<any> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.path}/${id}/enable`,
      {}
    );
  }

  deactivate(id: string): Observable<any> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.path}/${id}/disable`,
      {}
    );
  }

  delete(id: string): Observable<any> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.path}/disable/${id}`,
      {}
    );
  }


  private buildHttpParams(params?: ShowParamsDto): HttpParams {
    let httpParams: any = {};

    if(params?.title){
      httpParams.title = params?.title
    }
    if (params?.year) {
      httpParams.year = params?.year;
    }

    if (params?.month) {
      httpParams.month = params?.month;
    }

    if (params?.startDate) {
      httpParams.startDate = params?.startDate;
    }

    if (params?.released != undefined) {
      httpParams.released = params?.released;
    }

    if (params?.active != undefined) {
      httpParams.active = params?.active;
    }

    if (params?.idsClassrooms && params?.idsClassrooms.length > 0) {
      const idsClassRooms = params.idsClassrooms.join(',');
      httpParams.idsClassRooms = idsClassRooms;
    }

    if (params?.idsProfiles && params?.idsProfiles.length > 0) {
      const idsProfiles = params.idsProfiles.join(',');
      httpParams.idsProfiles = idsProfiles;
    }

    if (params?.idSchool && params?.idSchool != '') {
      httpParams.idSchool = params?.idSchool;
    }

    return httpParams;
  }

}
